// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb /deep/ {\n  padding: 20px 0;\n  margin-bottom: 40px;\n  background-color: transparent;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1;\n  color: #666; }\n  @media only screen and (max-width: 767px) {\n    .breadcrumb /deep/ {\n      display: none; } }\n  .breadcrumb /deep/ > .home {\n    background-image: url(\"/assets/images/breadcrumb-icon.png\");\n    background-repeat: no-repeat;\n    background-position: 0 1px;\n    padding-left: 16px; }\n  .breadcrumb /deep/ a {\n    color: #666; }\n  .breadcrumb /deep/ a:focus, .breadcrumb /deep/ a:hover {\n    color: #f50; }\n  .breadcrumb /deep/ > .active {\n    font-weight: 700;\n    color: #231f20; }\n  .breadcrumb /deep/ > li + li:before {\n    padding: 0 5px;\n    color: #ccc;\n    content: \">\"; }\n", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/bread-crumb/bread-crumb.component.scss
// module id = 997
// module chunks = 0